class Orbs {
    constructor() {
        this.amount = 60;
        this.speedX = 20;
        this.speedY = 150;
        this.animationDelay = 2000;
        this.animationInterval = null;
        this.orbs = [];
        this.direction = 0;
        this.windSteps = 0;
        this.wind = 0;
        this.animating = 0;
    }

    init() {
        let html = $("#page-wrapper");
        this.measure = document.getElementById("page-wrapper");
        let time = Date.now();
        for (let i = 0; i < this.amount; i++) {
            let orb = $("<orb>⬤</orb>");
            orb[0].speedX = this.speedX * (0.5 + (Math.random() * 0.5));
            orb[0].speedY = this.speedY * (0.5 + (Math.random() * 0.5));
            orb[0].style.fontSize = (Math.round(Math.random() * 4) + 1) + "px";
            orb[0].direction = Math.round(Math.random());
            orb[0].id = "orb_" + i;
            this.orbs.push(orb[0]);
            this.reset(orb[0]);

            html.append(orb);
            if (Date.now() - time > 15) {
                break;
            }
        }
        this.start();
    }

    start() {
        this.animationInterval = setInterval(() => {
            if (app.config.isFocused) {
                this.update();
            }
        }, this.animationDelay);
    }

    update() {
        let time = Date.now();
        if (this.animating === 0) {
            for (let i of this.orbs) {
                this.animating++;
                if (i) {
                    if (i.direction === 0) {
                        if (Math.random() > 0.9) {
                            i.direction = 1;
                        }
                        i.px -= i.speedX * Math.random().toFixed(2);
                    } else {
                        if (Math.random() > 0.9) {
                            i.direction = 0;
                        }
                        i.px += i.speedX * (0.5 + (Math.random().toFixed(2) * 0.5));
                    }
                    i.py -= (i.speedY * 0.2) + (i.speedY * (Math.random() * 0.2));
                    if (i.ttl-- < 1 || i.px > (window.innerWidth - 100) || i.px <= 100 || i.py > (this.measure.scrollHeight - 80) || i.py < 0) {
                        if (i.opacity <= 0 || (i.px > (window.innerWidth) || i.px <= 0 || i.py > this.measure.scrollHeight || i.py < 0)) {
                            this.reset(i);
                        } else {
                            i.opacity = 0;
                            i.style.opacity = 0;
                            i.style.left = i.px + "px";
                            i.style.top = i.py + "px";
                        }
                    } else {
                        if (i.style.display === "none") {
                            i.style.display = "block";
                        } else {
                            i.opacity = 0.1 + (Math.random().toFixed(2) * 0.7);
                            i.style.opacity = i.opacity;
                        }
                        i.style.left = i.px + "px";
                        i.style.top = i.py + "px";
                    }
                }
            }
            this.animating = 0;
        }
    }

    reset(i) {
        i.px = ((window.innerWidth * 0.2) + (Math.random() * (window.innerWidth * 0.6)));
        i.py = (this.measure.scrollHeight + 40) * Math.random();
        i.style.left = i.px + "px";
        i.style.top = i.py + "px";
        i.opacity = 0;
        i.style.opacity = 0;
        i.style.display = "none";
        i.ttl = 1 + Math.round(Math.random() * 10);
    }
}